__turbopack_context__.v({
  "className": "gamja_flower_282ecba2-module__Yk9Zea__className",
});
